import { Box } from "@mui/material";
import React from "react";

// ActionButton on this page: 56px height + 24px bottom offset +
// env(safe-area-inset-bottom) = 80px + inset of footprint above the page edge.
// Per design rule, keep at least 1.5 × button height (84px) of breathing
// room between the last row of content and the floating CTA, so the spacer
// is 80 + 84 + inset = 164px + inset. Requires viewport-fit=cover in
// index.html.
const BOX_STYLE = { height: "calc(164px + env(safe-area-inset-bottom))" };

const BottomPadding = () => {
	return <Box sx={BOX_STYLE} />;
};

export default React.memo(BottomPadding);
